import type { CSSProperties } from "react";

import { LitDivider } from "../Divider/LitDivider";
import { sysColors } from "@/assets/theme/colors";

/** Applied while keyboard roving focus is on a menu row (see `useMenuChordKeys`). */
export const MENU_ITEM_KEYBOARD_FOCUS_CLASS = "m360-menu-item-keyboard-focus";

/** Shared style tokens for overlay menus (`Menu`, `useActionMenu`) so they stay visually consistent. */

export const compactMenuItemCssVars = {
  "--md-menu-item-one-line-container-height": "36px",
  "--md-menu-item-two-line-container-height": "52px",
  "--md-menu-item-top-space": "4px",
  "--md-menu-item-bottom-space": "4px",
  "--md-menu-item-label-text-font": "var(--md-sys-typescale-body-medium-font, inherit)",
  "--md-menu-item-label-text-size": "14px",
  "--md-menu-item-label-text-weight": "400",
  "--md-menu-item-label-text-line-height": "20px",
  "--md-menu-item-label-text-tracking": "0.035px",
  "--md-menu-item-hover-state-layer-color": sysColors["sys-brand-on-surface"],
  "--md-menu-item-hover-state-layer-opacity": "0.08",
  "--md-menu-item-pressed-state-layer-color": sysColors["sys-brand-on-surface"],
  "--md-menu-item-pressed-state-layer-opacity": "0.12",
  "--md-focus-ring-width": "0",
  "--md-focus-ring-active-width": "0"
} as CSSProperties;

/** Tighter leading inset for rows with an icon; label-only rows keep Material's default 16px. */
export const iconRowCssVars = {
  ...compactMenuItemCssVars,
  "--md-menu-item-leading-space": "14px"
} as CSSProperties;

export const destructiveCssVars = {
  "--md-menu-item-label-text-color": sysColors["sys-brand-error"],
  "--md-menu-item-leading-icon-color": sysColors["sys-brand-error"],
  "--md-menu-item-trailing-icon-color": sysColors["sys-brand-error"]
} as CSSProperties;

const DIVIDER_SPACING = "my-2";
const DIVIDER_STYLE = {
  "--md-divider-color": `color-mix(in srgb, ${sysColors["sys-brand-outline-variant"]} 35%, transparent)`
} as CSSProperties;

/** Pass `inset={false}` when the surrounding container already provides the inset (e.g. mobile side sheet). */
export function MenuDivider({
  inset = true,
  className = DIVIDER_SPACING
}: { inset?: boolean; className?: string } = {}) {
  return <LitDivider role="separator" inset={inset} className={className} style={DIVIDER_STYLE} />;
}
